import { ApiClient as DeliveryStoreApiClient } from "./delivery-generated";
import { getDeliveryStoreApiEndpoint } from "#configuration/api-endpoints";

const endpoints = getDeliveryStoreApiEndpoint();
export const deliveryStoreApi = new DeliveryStoreApiClient(endpoints.store);
